import React, { Component } from 'react';
import { Tabs, Tab } from 'material-ui';
import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import PlaylistAddCheck from 'material-ui/svg-icons/av/playlist-add-check';
import GetApp from 'material-ui/svg-icons/action/get-app';
import SaveIcon from 'material-ui/svg-icons/content/save';
import ImportExport from 'material-ui/svg-icons/communication/import-export';
import FileCopy from 'material-ui/svg-icons/content/content-copy';
import SyncIcon from 'material-ui/svg-icons/notification/sync';
import SyncDisabled from 'material-ui/svg-icons/notification/sync-disabled';
import AttachMoney from 'material-ui/svg-icons/editor/attach-money';
import DirectionsCar from 'material-ui/svg-icons/notification/drive-eta';
import TimerIcon from 'material-ui/svg-icons/image/timer';
import LibraryAdd from 'material-ui/svg-icons/av/library-add';
import BedConfig from 'material-ui/svg-icons/maps/hotel';
import IconTextTile from './icon-text-tile';
import TabLabelWithMenu from './tab-with-menu';
import SyncDialog from './sync-dialog';
import injectSheet from 'react-jss';
import { downloadContractPdf as downloadContractPdfAction } from '../../../../../stores/contracting/contract-activities-products/contract-activities-products-actions';
import { syncProductInfo as syncProductInfoAction } from '../../../../../stores/contracting/dialogs/dialog-constants';
import R from 'ramda';

const styles = {
  container: { borderBottom: '1px solid #e0e0e0', padding: '0 8px', marginBottom: '4px', backgroundColor: '#f4f6fa' },
  tabItemContainer: { backgroundColor: 'transparent' },
  buttonStyle: { color: 'rgba(0, 0, 0, 0.87)', height: '32px' },
  tab: { textTransform: 'none' },
};

class TemplateDraftToolbar extends Component {
  constructor() {
    super();
    this.state = {
      value: 'template',
      menuOpen: '',
      syncDialog: {
        open: false,
      },
    };
  }
  onMenuOpen = value => e => {
    this.setState({
      menuOpen: this.state.menuOpen === value ? '' : value,
    });
  };
  onMenuClose = value => open => {
    if (!open && value === this.state.menuOpen) this.setState({ menuOpen: '' });
  };
  onTabChange = value => this.setState({ value });
  onReviewRates = () => {
    if (this.props.draftErrorsExist) window.alert('Please complete the draft first');
    else this.props.downloadContractPdf(this.props.contractId, this.props.contractState);
  };
  onClickFinalise = () => {
    const {
      draftErrorsExist,
      editHistory,
      goToSendUpdates,
      openPublishConfirmation,
      sentPartners,
      stagedUpdates,
      originFrom,
      draftType,
      progressCheck,
    } = this.props;
    const firstStepCompleted = !draftErrorsExist;
    const isEditedDraft = originFrom === 'edited';
    const isContractDraft = isEditedDraft && draftType !== 'template';
    const activeDraft = isContractDraft || (sentPartners && sentPartners.length);
    const stagedDraft = stagedUpdates && stagedUpdates.find(obj => obj.source === 'draft');
    if (R.isEmpty(editHistory)) {
      window.alert(`You haven't made any updates to this template.`);
    } else if (stagedDraft) {
      window.alert('Please remove draft from queue to continue editing.');
    } else if (!firstStepCompleted) {
      window.alert('Please complete the template before finalising it.');
      progressCheck();
    } else if (activeDraft) {
      goToSendUpdates();
    } else {
      openPublishConfirmation();
    }
  };
  goToMassRateChange = () => {
    const { locationName, contractId, push } = this.props;
    push(`/contracting/mass-rate-change/${contractId}/seasonRates?locationName=${locationName}`);
  };
  openSyncDialog = payload => () => {
    this.setState({ syncDialog: { open: true, ...payload } });
  };
  closeSyncDialog = () => this.setState({ syncDialog: { open: false } });
  dontSyncRates = () =>
    this.setState({ syncDialog: { ...this.state.syncDialog, syncRatesToo: false } });
  checkSyncRates = () =>
    this.setState({ syncDialog: { ...this.state.syncDialog, syncRatesToo: true } });
  doSync = () => {
    const { contractId, productId, syncProductInfo } = this.props;
    const {
      syncDialog: { syncRatesToo, value, currentlySynced },
    } = this.state;
    this.setState({ syncDialog: { ...this.state.syncDialog, loading: true } });
    syncProductInfo({
      contractId,
      productId,
      sectionInEdit: value,
      syncRatesToo,
      syncSection: !currentlySynced,
    }).then(() =>
      this.setState({ syncDialog: { ...this.state.syncDialog, loading: false, open: false } }),
    );
  };
  manageRatePackages = () => {
    const {
      productName,
      productId,
      ratePackageIndex,
      manageRatePackages,
    } = this.props;
    manageRatePackages({ productName, productId, ratePackageIndex });
  }
  render() {
    const {
      classes,
      progressCheck,
      importFromTemplate,
      copyDataFromAnotherProduct,
      manageOffers,
      manageExtras,
      isAccom,
      isDummyAccount,
      pureDocView,
      productType,
    } = this.props;
    const syncedSections = this.props.syncedSections || [];
    const tabData = [
      {
        labelText: 'Template',
        value: 'template',
      },
      {
        labelText: 'Import',
        value: 'import',
      },
      window.location.href.indexOf('/product/') > -1 ? {
        labelText: 'Sync',
        value: 'sync',
      } : null,
      {
        labelText: 'Tools',
        value: 'tools',
      },
    ].filter(x => x);
    const data = {
      template: [
        {
          text: 'Progress Check',
          Icon: PlaylistAddCheck,
          onClick: progressCheck,
        },
        {
          text: 'Review rates',
          Icon: GetApp,
          onClick: this.onReviewRates,
        },
        pureDocView ? null : {
          text: 'Finalise template',
          Icon: SaveIcon,
          onClick: this.onClickFinalise,
        },
      ].filter(x => x),
      import: [{
        text: 'Import template',
        Icon: ImportExport,
        onClick: importFromTemplate,
      }],
      sync: [
        {
          text: syncedSections.indexOf('seasons') > -1 ? 'Seasons synced' : 'Seasons not synced',
          Icon: syncedSections.indexOf('seasons') > -1 ? SyncIcon : SyncDisabled,
          iconColor: syncedSections.indexOf('seasons') > -1 ? '#00bcd4' : 'rgba(0, 0, 0, 0.87)',
          onClick: this.openSyncDialog({
            value: 'seasons',
            labelText: 'Seasons',
            currentlySynced: syncedSections.indexOf('seasons') > -1,
          }),
        },
        {
          text:
            syncedSections.indexOf('blackouts') > -1 ? 'Blackouts synced' : 'Blackouts not synced',
          Icon: syncedSections.indexOf('blackouts') > -1 ? SyncIcon : SyncDisabled,
          iconColor: syncedSections.indexOf('blackouts') > -1 ? '#00bcd4' : 'rgba(0, 0, 0, 0.87)',
          onClick: this.openSyncDialog({
            value: 'blackouts',
            labelText: 'Blackout Dates',
            currentlySynced: syncedSections.indexOf('blackouts') > -1,
          }),
        },
        {
          text: syncedSections.indexOf('allocation') > -1 ? 'Allocation synced' : 'Allocation not synced',
          Icon: syncedSections.indexOf('allocation') > -1 ? SyncIcon : SyncDisabled,
          iconColor: syncedSections.indexOf('allocation') > -1 ? '#00bcd4' : 'rgba(0, 0, 0, 0.87)',
          onClick: this.openSyncDialog({
            value: 'allocation',
            labelText: 'Allocation',
            currentlySynced: syncedSections.indexOf('allocation') > -1,
          }),
        },
        isAccom ? null : {
          text: syncedSections.indexOf('pickup') > -1 ? 'Pick Up / Opening synced' : 'Pick Up / Opening not synced',
          Icon: syncedSections.indexOf('pickup') > -1 ? SyncIcon : SyncDisabled,
          iconColor: syncedSections.indexOf('pickup') > -1 ? '#00bcd4' : 'rgba(0, 0, 0, 0.87)',
          onClick: this.openSyncDialog({
            value: 'pickup',
            labelText: 'Pick Up / Opening',
            currentlySynced: syncedSections.indexOf('pickup') > -1,
          }),
        },
        isAccom ? null : {
          text: syncedSections.indexOf('dropoff') > -1 ? 'Drop Off / Closing synced' : 'Drop Off / Closing not synced',
          Icon: syncedSections.indexOf('dropoff') > -1 ? SyncIcon : SyncDisabled,
          iconColor: syncedSections.indexOf('dropoff') > -1 ? '#00bcd4' : 'rgba(0, 0, 0, 0.87)',
          onClick: this.openSyncDialog({
            value: 'dropoff',
            labelText: 'Drop Off / Closing',
            currentlySynced: syncedSections.indexOf('dropoff') > -1,
          }),
        },
        {
          text:
            syncedSections.indexOf('cancellations') > -1
              ? 'Seasonal Cancellations synced'
              : 'Seasonal Cancellations not synced',
          Icon: syncedSections.indexOf('cancellations') > -1 ? SyncIcon : SyncDisabled,
          iconColor:
            syncedSections.indexOf('cancellations') > -1 ? '#00bcd4' : 'rgba(0, 0, 0, 0.87)',
          onClick: this.openSyncDialog({
            value: 'cancellations',
            labelText: 'Seasonal Cancellations',
            currentlySynced: syncedSections.indexOf('cancellations') > -1,
          }),
        },
      ].filter(x => x),
      tools: [
        {
          text: 'Mass Rate Change',
          Icon: AttachMoney,
          onClick: this.goToMassRateChange,
        },
        {
          text: 'Manage Extras',
          Icon: DirectionsCar,
          onClick: manageExtras,
        },
        {
          text: 'Manage Special Offers',
          Icon: TimerIcon,
          onClick: manageOffers,
        },
      ],
    };
    if (window.location.href.indexOf('/product/') > -1) {
      data.import.push({
        text: `Import product data`,
        Icon: FileCopy,
        onClick: copyDataFromAnotherProduct,
      });
      data.tools.push({
        text: `Manage Rate Packages`,
        Icon: LibraryAdd,
        tooltip: 'Rate packages allow you to load different rates types for the same product and season. For instance, if you have an English/Foreign Language rate or Bed & Breakfast/Room Only rate.',
        onClick: this.manageRatePackages,
      });
      if (isDummyAccount && productType === 'Accommodation') {
        data.tools.push({
          text: `Update Bedding Config`,
          Icon: BedConfig,
          tooltip: '',
          onClick: this.props.updateBeddingConfig,
        });
      }
    }
    return (
      <div className={classes.container}>
        <Tabs
          value={this.state.value}
          style={{
            paddingRight:
              window.location.href.indexOf('/product/') > -1
                ? 'calc(100% - 500px)'
                : 'calc(100% - 300px)',
            borderBottom: '1px solid #e0e0e0',
          }}
          tabItemContainerStyle={styles.tabItemContainer}
          inkBarStyle={{ backgroundColor: '#00bcd4' }}
          onChange={this.onTabChange}
        >
          {
            tabData.map(obj => (
              <Tab
                key={obj.labelText}
                label={
                  <TabLabelWithMenu
                    {...obj}
                    menuOpen={this.state.menuOpen === obj.value}
                    onMenuClose={this.onMenuClose}
                    onMenuOpen={this.onMenuOpen}
                    menuData={data[obj.value]}
                  />
                }
                buttonStyle={styles.buttonStyle}
                style={styles.tab}
                value={obj.value}
              />
            ))
          }
        </Tabs>
        <div className="flex-center">
          {(() => {
            if (this.state.value === 'sync' && window.location.href.indexOf('/product/') === -1) {
              return <div />;
            }
            if (this.state.value) {
              return data[this.state.value].map(obj => <IconTextTile key={obj.text} {...obj} />);
            }
          })()}
        </div>
        <SyncDialog
          {...this.state.syncDialog}
          onRequestClose={this.closeSyncDialog}
          onConfirm={this.doSync}
          dontSyncRates={this.dontSyncRates}
          checkSyncRates={this.checkSyncRates}
          isAccom={isAccom}
        />
      </div>
    );
  }
}

TemplateDraftToolbar.propTypes = {
  classes: React.PropTypes.object,
  syncedSections: React.PropTypes.array,
  progressCheck: React.PropTypes.func,
  importFromTemplate: React.PropTypes.func,
  copyDataFromAnotherProduct: React.PropTypes.func,
  manageOffers: React.PropTypes.func,
  manageExtras: React.PropTypes.func,
  contractId: React.PropTypes.string,
  productId: React.PropTypes.string,
  syncProductInfo: React.PropTypes.func,
  draftErrorsExist: React.PropTypes.bool,
  editHistory: React.PropTypes.array,
  goToSendUpdates: React.PropTypes.func,
  openPublishConfirmation: React.PropTypes.func,
  sentPartners: React.PropTypes.array,
  stagedUpdates: React.PropTypes.array,
  originFrom: React.PropTypes.string,
  draftType: React.PropTypes.string,
  downloadContractPdf: React.PropTypes.func,
  contractState: React.PropTypes.string,
  push: React.PropTypes.func,
  locationName: React.PropTypes.string,
  isAccom: React.PropTypes.bool,
  productName: React.PropTypes.string,
  productType: React.PropTypes.string,
  ratePackageIndex: React.PropTypes.number,
  manageRatePackages: React.PropTypes.func,
  isDummyAccount: React.PropTypes.bool,
  pureDocView: React.PropTypes.bool,
  updateBeddingConfig: React.PropTypes.func,

};

const mapState = ({ contracting, user }) => ({
  ...contracting.contractActivitiesProducts.get('leftNav').toJS(),
  productId: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productId']),
  productName: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productName']),
  productType: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productType']),
  ratePackageIndex: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'ratePackageIndex']),
  draftErrorsExist: contracting.contractActivitiesProducts.get('draftErrors').toJS().errorExist,
  isAccom: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productType']) === 'Accommodation',
  isDummyAccount: user.get('isDummyAccount'),
  pureDocView: user.get('pureDocView'),
});

const mapActions = {
  push: pushAction,
  progressCheck: () => ({ type: 'TOGGLE_DRAFT_ERRORS_DIALOG' }),
  syncProductInfo: syncProductInfoAction,
  downloadContractPdf: downloadContractPdfAction,
  openPublishConfirmation: () => ({
    type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG',
    payload: { open: true, title: 'Finalise Template' },
  }),
  goToSendUpdates: () => ({ type: 'SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG' }),
  importFromTemplate: () => ({
    type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
    payload: { type: 'importFromTemplate' },
  }),
  copyDataFromAnotherProduct: () => ({
    type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
    payload: {
      type: 'copyDataFromAnotherProduct',
      data: {
        title: 'Copy data from another product',
        noShowIfEmpty: false,
      },
    },
  }),
  manageOffers: () => ({
    type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
    payload: {
      type: 'manageExtrasOffers',
      data: {
        title: 'Manage Special Offers',
      },
      offersOrExtras: {
        type: 'offers',
      },
    },
  }),
  manageExtras: () => ({
    type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
    payload: {
      type: 'manageExtrasOffers',
      data: {
        title: 'Manage Extras',
      },
      offersOrExtras: {
        type: 'extras',
      },
    },
  }),
  manageRatePackages: ({ productName, productId, ratePackageIndex }) => ({
    type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
    payload: {
      type: 'manageRatePackage',
      title: `Manage Rate Packages for ${productName}`,
      data: { productId, ratePackageIndex },
    },
  }),
  updateBeddingConfig: () => ({
    type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
    payload: {
      type: 'updateBeddingConfig',
      data: {
        title: 'Update Bedding Configuration',
      },
    },
  }),
};

export default injectSheet(styles)(
  connect(
    mapState,
    mapActions,
  )(TemplateDraftToolbar),
);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/template-draft-toolbar/index.jsx